import {of} from 'rxjs';
import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {AuthStore} from '../../+store/auth.store';

export function RememberMeGuard(): CanActivateFn {
	return () => {
		const authStore: AuthStore = inject(AuthStore);
		const isRememberMeChecked: boolean = authStore.state().rememberMe;
		if (isRememberMeChecked) {
			if (authStore.isAuthenticated()) {
				const router: Router = inject(Router);
				return router.navigate(['home']).then(() => false);
			}
		} else {
			// authService.logout('login');
		}
		return of(true);
	};
}
